import React, { useState } from "react";
import {
  MdOutlineDashboard, MdAssignment, MdOutlineDescription,
  MdListAlt, MdPeople, MdLogout, MdMenu, MdClose,
  MdChevronLeft, MdChevronRight, MdOutlineComputer,
  MdAdminPanelSettings, MdPerson
} from "react-icons/md";
import { FaTasks } from "react-icons/fa";
import "./Sidebar.css";

export default function Sidebar({ user, page, setPage, onLogout }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isAdmin = user.role === "admin";

  const navItems = [
    ...(isAdmin ? [
      { id:"admin",   label:"Dashboard",    icon:<MdOutlineDashboard /> },
      { id:"users",   label:"Manage Users", icon:<MdPeople /> },
      { id:"tasks",   label:"All Tasks",    icon:<FaTasks /> },
    ] : [
      { id:"tasks",   label:"My Tasks",     icon:<FaTasks /> },
    ]),
    { id:"form",    label:"New Report",   icon:<MdOutlineDescription /> },
    { id:"list",    label:"All Reports",  icon:<MdListAlt /> },
  ];

  const SidebarContent = () => (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* Brand */}
      <div className="sidebar-brand">
        <div className="brand-icon"><MdOutlineComputer /></div>
        {!collapsed && <div className="brand-text"><span>Daily Report</span><small>Vishwnet</small></div>}
        <button className="collapse-btn no-print" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? <MdChevronRight /> : <MdChevronLeft />}
        </button>
      </div>

      {/* User card */}
      <div className="sidebar-user">
        <div className="user-avatar">{user.name.charAt(0).toUpperCase()}</div>
        {!collapsed && (
          <div className="user-info">
            <div className="user-name">{user.name}</div>
            <div className={`user-role-badge ${isAdmin ? "admin" : "user"}`}>
              {isAdmin ? <><MdAdminPanelSettings /> Admin</> : <><MdPerson /> Employee</>}
            </div>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav className="sidebar-nav">
        {!collapsed && <div className="nav-section-label">NAVIGATION</div>}
        {navItems.map(item => (
          <button
            key={item.id}
            className={`nav-item ${page === item.id ? "active" : ""}`}
            onClick={() => { setPage(item.id); setMobileOpen(false); }}
            title={collapsed ? item.label : ""}
          >
            <span className="nav-icon">{item.icon}</span>
            {!collapsed && <span className="nav-label">{item.label}</span>}
            {!collapsed && page === item.id && <span className="nav-dot" />}
          </button>
        ))}
      </nav>

      {/* Logout */}
      <div className="sidebar-footer">
        <button className="nav-item logout-btn" onClick={onLogout} title={collapsed ? "Logout" : ""}>
          <span className="nav-icon"><MdLogout /></span>
          {!collapsed && <span className="nav-label">Logout</span>}
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile toggle */}
      <button className="mobile-toggle no-print" onClick={() => setMobileOpen(!mobileOpen)}>
        {mobileOpen ? <MdClose /> : <MdMenu />}
      </button>

      {/* Mobile overlay */}
      {mobileOpen && <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />}

      {/* Desktop sidebar */}
      <div className="sidebar-desktop"><SidebarContent /></div>

      {/* Mobile sidebar */}
      <div className={`sidebar-mobile ${mobileOpen ? "open" : ""}`}><SidebarContent /></div>
    </>
  );
}
